import { usePropertyAsIsValue } from '../../../queries/PropertyFields/NonRentalCoreFields';
import { MoneyBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';
import { formatCurrencyOrUndefined } from '@apply/ui';

interface CurrentAsIsValueProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const CurrentAsIsValue: React.FC<CurrentAsIsValueProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const [asIsValue, set_asIsValue] = usePropertyAsIsValue(propertyGuid);
    const label = 'What is the current value as is?';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(asIsValue ?? 0)}
                />
            ) : (
                <MoneyBox
                    id='asIsValue'
                    allowNegative={false}
                    value={asIsValue}
                    onChange={(value) => set_asIsValue(value)}
                    required={required}
                    label={label}
                    displayChange={false}
                    validateValue={(value) => Number(value) > 0}
                    validateValueMessage='Current as is value must be greater than 0'
                />
            )}
        </>
    );
};
